"use strict";

exports.__esModule = true;
var _AlertGrid = require("./AlertGrid");
Object.keys(_AlertGrid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertGrid[key]) return;
  exports[key] = _AlertGrid[key];
});